import { IMAGES, LINKS, MOBILE_EXTRA_LINKS, NAV_LINKS } from "@/data/content";
import { Link } from "react-router-dom";
import { LogIn } from "lucide-react";
import { SocialLinks } from "@/components/site/SocialLinks";

const FOOTER_LINKS = [
  ...NAV_LINKS.filter((l) => l.id !== "careers").flatMap((l) => l.children || [l]),
  ...MOBILE_EXTRA_LINKS,
  ...NAV_LINKS.filter((l) => l.id === "careers"),
];

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-navy/10 bg-snow py-12">
    <div className="mx-auto grid max-w-6xl gap-10 px-5 sm:px-8 md:grid-cols-[1fr_auto] md:gap-16">
      <div>
        <img src={IMAGES.logo} alt="PKR Recruiting" className="h-10 w-auto" />
        <p className="mt-4 text-sm md:whitespace-nowrap leading-relaxed text-ink/60">
          Boutique recruiting experts for growing teams. Here when you're slammed, gone when you're not.
        </p>
        <SocialLinks className="mt-6" />
      </div>
      <nav className="grid grid-flow-col grid-rows-4 gap-x-12 gap-y-3 text-sm font-medium text-ink/70" data-testid="footer-nav">
        {FOOTER_LINKS.map((l) => (
          <Link
            key={l.id}
            data-testid={`footer-link-${l.id}`}
            to={l.href}
            className="link-underline w-fit hover:text-ink"
            {...(l.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
          >
            {l.label}
          </Link>
        ))}
      </nav>
    </div>
    <div className="mx-auto mt-10 max-w-6xl px-5 sm:px-8">
      <div className="flex flex-col gap-3 border-t border-navy/10 pt-6 text-xs text-ink/50 sm:flex-row sm:items-center sm:justify-between">
        <p data-testid="footer-copyright">
          Panna Knows LLC dba PKRecruiting &nbsp;|&nbsp; © {new Date().getFullYear()}
        </p>
        <a
          data-testid="footer-pkrhub-login"
          href={LINKS.pkrhub}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex w-fit items-center gap-1.5 font-medium transition-colors hover:text-navy"
        >
          <LogIn className="h-3.5 w-3.5" /> PKRHub Team Login
        </a>
      </div>
    </div>
  </footer>
);
